import { InteractionScreen } from "../../Redux/screenInteractionsSlice"
import { OptionButton } from "../ActionButtons/HomeButton"
import { ButtonActionResolver } from "../Resolvers/ButtonActionResolver"

interface IProps {
    screen: InteractionScreen;
}

export const OptionButtons: React.FC<IProps> = ({screen}) => {
    return (
        <div className="flex justify-center gap-4" >
            <ButtonActionResolver button="start" screen={screen}>
                <OptionButton button='start'/>
            </ButtonActionResolver>
            <ButtonActionResolver button="home" screen={screen}>
                <OptionButton button='home'/>
            </ButtonActionResolver>
        </div>
    )
}